import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { registerServiceWorker } from './lib/register-sw'
import { captureInstallPrompt } from './lib/pwa-install'
import { installClientDiagnostics } from './lib/client-diagnostics'
import { handleOAuthPopupReturn } from './lib/evotech-oauth-return'
import { isLandingHost } from './lib/landing'
import { LandingPage } from './pages/public/landing-page'
import { initI18n } from './lib/i18n'

// PWA: bắt sự kiện cài của trình duyệt NGAY (có thể bắn trước khi React dựng xong) để nút "Tải ứng dụng" cài được một chạm.
captureInstallPrompt()

// Hộp đen cho nút "Góp ý": nhớ vài lỗi JS / API lỗi gần nhất (chỉ gửi đi khi người dùng đồng ý đính kèm).
installClientDiagnostics()

// Popup uỷ quyền Evotech quay về: báo kết quả cho cửa sổ eCDP rồi tự đóng — KHÔNG dựng app (popup hẹp bị coi là màn điện thoại).
// Tên miền giới thiệu (ecdp.vn) mở ở trang chủ → chỉ dựng trang giới thiệu, không dựng app (không đòi đăng nhập).
const landingRoot = isLandingHost(window.location.hostname) && window.location.pathname === '/'

if (landingRoot) {
  createRoot(document.getElementById('root')!).render(<LandingPage />)
} else if (!handleOAuthPopupReturn()) {
  const render = () =>
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  // Nạp bản dịch của ngôn ngữ đang chọn trước khi vẽ (chunk nhỏ, tải song song).
  // Lỗi nạp → vẫn vẽ; i18next rơi về tiếng Việt thay vì trắng màn hình.
  initI18n().then(render, render)

  // PWA: service worker chỉ lưu vỏ ứng dụng (public/sw.js), không đụng dữ liệu API.
  registerServiceWorker()
}
